import { render } from "./BrandTyreRange.vue?vue&type=template&id=185efbc0&scoped=true"
import script from "./BrandTyreRange.vue?vue&type=script&lang=js"
export * from "./BrandTyreRange.vue?vue&type=script&lang=js"

import "./BrandTyreRange.vue?vue&type=style&index=0&id=185efbc0&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185efbc0"]])

export default __exports__